<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="' الاحداث'" :to="{name: 'parent-events'}">  الاحداث</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                       الاحداث

                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <button class="btn btn-success mb-2" v-if="searchingMode == 0" @click="searchingMode = 1">فلاتر البحث</button>
                                <button class="btn btn-danger mb-2" v-if="searchingMode == 1" @click="searchingMode = 0">X</button>
                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-6 mt-2">
                                          <label for="">من تاريخ </label>
                                          <date-picker v-model="data.searching.date_from" :editable="true"  :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4 mt-2">

                                          <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث">
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">التاريخ</th>
                                                <th @click="resortData();">اسم الحدث</th>
                                                <th @click="resortData();">الحلقة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>{{item.event_date}}</td>
                                                <td>{{item.name}}</td>
                                                <td>{{item.lesson ? item.lesson.name : '---'}}</td>
                                                <td class="text-center">

                                                    <div class="dropdown custom-dropdown">
                                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="flaticon-dot-three fs-17"></i>
                                                        </a>

                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                          <router-link :title="'إظهار'" class="dropdown-item dots-options" href="javascript:void(0);" :to="{name: 'parent-events.show', params: {id: item.id}}"><i class="flaticon-381-focus"></i> إظهار</router-link>

                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                              <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">التاريخ</th>
                                                <th @click="resortData();">اسم الحدث</th>
                                                <th @click="resortData();">الحلقة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      printData: {
      },
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       lessons: [],
       groups: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
      getIndexData(page){
        this.$baseApi.get('/parent-events?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.events;
               this.data.data = response.data.data.events.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    }
  }
};
</script>
<style>
</style>
